import { render, staticRenderFns } from "./SendProps.vue?vue&type=template&id=4b8fd1a7&scoped=true"
import script from "./SendProps.vue?vue&type=script&lang=js"
export * from "./SendProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fd1a7",
  null
  
)

export default component.exports